import { Campo, Input } from "@/components/ui";
import { Chips, Stepper } from "@/components/ui/controles";
import { useDatos } from "../store/store";
import { setSetup } from "../store/acciones";
import { SeccionLayout, Bloque } from "../componentes/SeccionLayout";
import { Ejemplo } from "../componentes/Ejemplo";

export function SobreTi() {
  const s = useDatos((x) => x.inputs.setup);
  const apply = useDatos((x) => x.apply);
  const edadRara = s.age !== null && s.age > 120;
  return (
    <SeccionLayout id="sobre-ti" intro="Cuatro datos que usa todo el modelo. Aproxima: si dudas, pon el de en medio y sigue.">
      <Bloque titulo="Tú">
        <div className="flex flex-col gap-5">
          <Campo etiqueta="Tu edad" htmlFor="edad" error={edadRara ? "¿Pusiste el año? Aquí va tu edad en años." : undefined}>
            <Stepper id="edad" valor={s.age} min={18} max={100} sufijo="años" onChange={(v) => apply(setSetup({ age: v }))} />
          </Campo>
          <Campo etiqueta="¿Hasta qué edad quieres ver tu patrimonio?" htmlFor="horizonte" ayuda="El modelo viene en 90. Es hasta dónde llega tu proyección." error={s.targetAge !== null && s.age !== null && s.targetAge <= s.age ? "Tiene que ser mayor que tu edad." : undefined}>
            <Stepper id="horizonte" valor={s.targetAge} min={60} max={110} sufijo="años" onChange={(v) => apply(setSetup({ targetAge: v }))} />
          </Campo>
          <Campo etiqueta="Año del modelo" htmlFor="anio" ayuda="Normalmente el año de hoy.">
            <Input id="anio" inputMode="numeric" className="tabular max-w-32" value={s.year ?? ""} onChange={(e) => { const n = Number(e.target.value.replace(/\D/g, "")); apply(setSetup({ year: e.target.value === "" ? null : n })); }} />
          </Campo>
        </div>
      </Bloque>
      <Bloque titulo="Moneda" ayuda="Una sola moneda para todo: ingresos, gastos, lo que tienes, lo que debes y tus objetivos.">
        <Chips etiqueta="Moneda" valor={s.currency === "USD" ? "USD" : "MXN"} onChange={(v) => apply(setSetup({ currency: v }))}
          opciones={[{ valor: "MXN", etiqueta: "Pesos (MXN)" }, { valor: "USD", etiqueta: "Dólares (USD)" }]} />
        <p className="mt-3 text-sm text-tinta-suave">Elige dólares solo si vives, ganas y gastas en dólares. Si tienes ETFs en dólares pero vives en pesos, es MXN: el modelo convierte solo.</p>
        <div className="mt-3"><Ejemplo campo="setup" /></div>
      </Bloque>
    </SeccionLayout>
  );
}
